<template>
  <v-dialog
    :key="changeKey"
    v-model="dialog"
    @input="(v) => v || closeDialog()"
    max-width="688px"
  >
    <v-card-text class="modal-header">
      <v-img
        @click="closeDialog"
        class="cancel-image"
        src="../assets/icons/cancel.png"
        height="15px"
        width="15px"
      />
      <div class="text-center py-3">
        <h3>{{ dialogTitle }}</h3>
      </div>
    </v-card-text>
    <v-card class="d-flex justify-content-center">
      <!-- <v-card-title>{{ dialogTitle }}</v-card-title> -->
      <v-card-text>
        <v-form class="ma-2 mt-3" ref="updateBox" lazy-validation>
          <div class="fields-group my-5">
            <span class="group-title">{{
              'lng_alarm_options' | translate
            }}</span>
            <v-text-field
              :label="'lng_email_alarm_label' | translate"
              v-model="alarmEmail"
            ></v-text-field>
            <AlarmPhoneNumbers
              :alarmPhone="alarmPhone"
              @updatePhone="(phone, index) => onUpdatePhone(phone, index)"
            />
            <v-text-field
              :label="'lng_alarm_prefix_label' | translate"
              v-model="alarmPrefix"
              counter="15"
              maxlength="15"
            ></v-text-field>
          </div>

          <div class="fields-group my-5">
            <span class="group-title">{{
              'lng_service_settings' | translate
            }}</span>
            <v-text-field
              :label="'lng_service_settings_label' | translate"
              v-model="serviceEmail"
            ></v-text-field>
            <v-text-field
              :label="'lng_days_till_service' | translate"
              v-model="daysTillService"
              type="number"
            ></v-text-field>
            <v-text-field
              :label="'lng_note_txt' | translate"
              v-model="internalcomment"
            ></v-text-field>
          </div>

          <div class="fields-group my-5">
            <span class="group-title">{{
              'lng_operation_settings' | translate
            }}</span>
            <v-text-field
              :label="'lng_operation_settings_label' | translate"
              v-model="operationEmail"
            ></v-text-field>
          </div>

          <div class="fields-group my-5">
            <span class="group-title">{{ 'lng_misc_txt' | translate }}</span>
            <v-text-field
              :label="'lng_th_mac_number_txt' | translate"
              v-model="macNumber"
            ></v-text-field>
            <v-select
              :label="'lng_sewer_type_txt' | translate"
              class="mt-0 pt-0"
              :items="sewerTypes"
              :value="selectedSewerType"
              item-text="name"
              item-value="value"
              menu-props="auto"
              return-object
              @change="
                (value) => {
                  selectedSewerType = value;
                }
              "
            >
              <template v-slot:selection="{ item, index }">
                <span class="flags pl-2">{{ item.name | translate }}</span>
              </template>
              <template v-slot:item="{ item, index }">
                <span class="flags pl-2">{{ item.name | translate }}</span>
              </template>
            </v-select>
            <v-select
              :label="'lng_equipment_type_txt' | translate"
              class="mt-0 pt-0"
              :items="equipmentTypes"
              :value="selectedEquipmentType"
              item-text="name"
              item-value="value"
              menu-props="auto"
              return-object
              @change="
                (value) => {
                  selectedEquipmentType = value;
                }
              "
            >
              <template v-slot:selection="{ item, index }">
                <span class="flags pl-2">{{ item.name | translate }}</span>
              </template>
              <template v-slot:item="{ item, index }">
                <span class="flags pl-2">{{ item.name | translate }}</span>
              </template>
            </v-select>
            <div>
              <v-radio-group mt-0 v-model="srContractValue" row 
                :disabled="authLevel === '1'"
              >
                <template v-slot:label
                  ><span>{{
                    'lng_th_service_contract_txt' | translate
                  }}</span></template
                >
                <v-radio :label="'lng_yes_txt' | translate" value="1"></v-radio>
                <v-radio :label="'lng_no_txt' | translate" value="0"></v-radio>
              </v-radio-group>
              <v-select
                :label="'lng_th_subscription_txt' | translate"
                class="mt-0 pt-0"
                :items="subscriptionTierValues"
                v-model="subscriptionValue"
                item-text="name"
                item-value="value"
                menu-props="auto"
                :disabled="authLevel === '1'"
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.name | translate }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <span>{{ item.name | translate }}</span>
                </template>
              </v-select>
            </div>
          </div>
          <div class="fields-group my-5">
            <span class="group-title">{{ 'lng_th_address' | translate }}</span>
            <v-text-field
              :label="'lng_address1_text' | translate"
              v-model="address1"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              :label="'lng_address2_text' | translate"
              v-model="address2"
            ></v-text-field>
            <v-row>
              <v-text-field
                style="margin-right: 15px; margin-left: 15px;"
                :label="'lng_zip_text' | translate"
                v-model="zip"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                style="margin-right: 15px; margin-left: 15px;"
                :label="'lng_city_text' | translate"
                v-model="city"
                :rules="[rules.required]"
              ></v-text-field>
            </v-row>
            <v-select
              class="mt-0 pt-0"
              :items="countryItems"
              :value="selectedCountry.value"
              item-text="name"
              item-value="value"
              menu-props="auto"
              return-object
              @change="
                (value) => {
                  selectedCountry = value;
                }
              "
            ></v-select>
          </div>
          <p class="warning-error mt-2" v-if="error">{{ error }}</p>
          <div class="date-header d-flex justify-content-center py-5 mt-3">
            <v-btn
              color="#0B7894"
              dark
              @click="validate"
              :loading="showLoading"
              >{{ 'lng_save_txt' | translate }}</v-btn
            >
          </div>
        </v-form>
      </v-card-text>
      <Alert
        v-if="alertToggle"
        :message-data="flashMessageData"
        :alert-toggle="alertToggle"
        @alertToggleUpdate="alertToggle = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import {
  countries,
  sewerTypeValues,
  equipmentTypeValues,
  subscriptionTierValues,
} from '../common/Constant';
import { getCountryByPhone } from '../common/HelperFunctions.js';
import UserService from '../services/user-service';
import router from '../router';
import { translateFunc } from '../common/Filters';
import Alert from '../components/Alert';
import VuePhoneNumberInput from 'vue-phone-number-input';
import AlarmPhoneNumbers from './AlarmPhoneNumbers.vue';

export default {
  name: 'updateBoxAddress',
  components: {
    Alert,
    VuePhoneNumberInput,
    AlarmPhoneNumbers,
  },
  data() {
    return {
      dialog: false,
      systemId: '',
      showPass: false,
      address1: '',
      address2: '',
      city: '',
      zip: '',
      countryItems: countries,
      selectedCountry: {
        name: 'Denmark',
        value: 'DK',
      },
      rules: {
        required: (value) => !!value || translateFunc('lng_required_text'),
        counter: (value) =>
          value.length <= 20 || translateFunc('lng_required_length'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return (
            pattern.test(value) || translateFunc('lng_required_validate_email')
          );
        },
      },
      showLoading: false,
      error: '',
      alarmEmail: '',
      serviceEmail: '',
      daysTillService: '',
      internalcomment: '',
      operationEmail: '',
      alarmPhone: [''],
      alarmPrefix: '',
      alertToggle: false,
      flashMessageData: {},
      phoneObject: [],
      translations: {
        countrySelectorLabel: translateFunc('lng_country_code_txt'),
        countrySelectorError: translateFunc('lng_country_code_error_txt'),
        phoneNumberLabel: translateFunc('lng_phone_alarm_label'),
        example: translateFunc('lng_example_text'),
      },
      macNumber: null,
      sewerTypes: sewerTypeValues,
      selectedSewerType: {
        name: 'lng_other_txt',
        value: 'other',
      },
      equipmentTypes: equipmentTypeValues,
      selectedEquipmentType: {
        name: 'lng_select_eq_type_txt',
        value: 'other',
      },
      subscriptionTierValues,
      srContractValue: '0',
      subscriptionValue: '0',
      authLevel: null,
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
    closeDialog: {
      type: Function,
      default: undefined,
    },
    dialogTitle: {
      type: String,
      default: 'Dialog',
    },
    completeAddress: {
      type: Object,
      default: () => ({}),
    },
    userToken: {
      type: String,
      default: '',
    },
    changeKey: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
    completeAddress: {
      handler(newVal) {
        if (!newVal || !Object.keys(newVal).length) return;

        this.systemId = newVal.id || '';
        this.address1 = newVal.addr1 || '';
        this.address2 = newVal.addr2 || '';
        this.city = newVal.city || '';
        this.zip = newVal.zip || '';
        this.alarmEmail = newVal.alarmemail || '';
        this.serviceEmail = newVal.serviceemail || '';
        this.daysTillService =
          newVal.daystillservice !== undefined &&
          newVal.daystillservice !== null &&
          newVal.daystillservice !== ''
            ? Number(newVal.daystillservice)
            : '';
        this.internalcomment = newVal.internalcomment || '';
        this.operationEmail = newVal.operationemail || '';
        this.phoneObject = [];
        this.alarmPhone = newVal.alarmsms
          ? newVal.alarmsms
              .split(',')
              .map((item) => getCountryByPhone(item.trim()))
              .filter((item) => item !== '')
          : [''];
        if (!this.alarmPhone.length) {
          this.alarmPhone = [''];
        }
        this.alarmPrefix = newVal.alarmprefix || '';
        this.macNumber = newVal.mecnumber || null;
        this.srContractValue = newVal.servicecontract || '0';
        this.subscriptionValue = newVal.subscription || '0';
        this.error = '';

        let index = countries.findIndex((e) => e.name === newVal.country);
        this.selectedCountry =
          index !== -1
            ? countries[index]
            : { name: 'Denmark', value: 'DK' };

        let sewerTypeIndex = sewerTypeValues.findIndex(
          (e) => e.value === newVal.sewertype
        );
        this.selectedSewerType =
          sewerTypeIndex !== -1
            ? sewerTypeValues[sewerTypeIndex]
            : { name: 'lng_other_txt', value: 'other' };

        let eqTypeIndex = equipmentTypeValues.findIndex(
          (e) => e.value === newVal.uwsequipment
        );
        this.selectedEquipmentType =
          eqTypeIndex !== -1
            ? equipmentTypeValues[eqTypeIndex]
            : { name: 'lng_select_eq_type_txt', value: 'other' };
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.authLevel = sessionStorage.getItem('authLevel');
  },
  methods: {
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.updateBox.validate()) {
          await this.getLatLng();
        }
      });
    },
    async getLatLng() {
      let combinedAddress = `${this.address1} ${this.address2} ${this.city} ${this.zip} ${this.selectedCountry.name}`;
      let location = await UserService.googleApiForLatLng(combinedAddress);
      if (location.results.length) {
        await this.saveBox(location.results[0].geometry.location);
      } else {
        console.log('location not found');
        this.error = translateFunc('lng_missing_city_txt');
        this.showAlert({
          msg: translateFunc('lng_missing_city_txt'),
          status: 1,
        });
      }
    },
    async saveBox(location) {
      this.error = '';
      this.showLoading = true;
      let response;

      // if(!this.phoneObject.formattedNumber || (this.phoneObject.formattedNumber && this.phoneObject.isValid) ){

      let phoneNumbersArray = this.phoneObject
        .map((obj) =>
          obj.formattedNumber ? obj.formattedNumber.replace('+', '') : ''
        )
        .filter((num) => num);
      // Fall back to original SMS list when phone inputs have not emitted yet
      let phoneNumber = phoneNumbersArray.length
        ? phoneNumbersArray.join(',')
        : this.completeAddress.alarmsms || '';

      try {
        let paramString = `systemid=${
          this.completeAddress.id
        }&adr1=${encodeURIComponent(this.address1)}&adr2=${encodeURIComponent(
          this.address2
        )}&city=${this.city}&zip=${this.zip}&country=${
          this.selectedCountry.name
        }&lat=${location.lat}&lng=${location.lng}&alarmemail=${
          this.alarmEmail
        }&serviceemail=${this.serviceEmail}&daystillservice=${
          this.daysTillService
        }&internalcomment=${encodeURIComponent(
          this.internalcomment || ''
        )}&operationemail=${
          this.operationEmail
        }&alarmsms=${phoneNumber}&alarmprefix=${this.alarmPrefix}&mecnumber=${
          this.macNumber
        }&sewertype=${this.selectedSewerType.value}&uwsequipment=${
          this.selectedEquipmentType.value
        }&servicecontract=${this.srContractValue}&subscription=${
          this.subscriptionValue
        }`;

        response = await UserService.changeBoxSettings(
          this.userToken,
          paramString
        );
      } catch (e) {
        this.error = translateFunc('lng_try_again_txt');
        this.showLoading = false;
        this.showAlert({ msg: translateFunc('lng_try_again_txt'), status: 1 });
      }
      if (!response.status) {
        this.error = '';
        this.showLoading = false;
        this.$emit('updateLocalData');
        this.showAlert(response);
        setTimeout(() => {
          this.closeDialog();
        }, 1000);
      } else {
        this.showLoading = false;
        this.error = response.msg;
        this.showAlert(response);
      }
      // } else {
      //   this.error = "phone number is invalid";
      //   this.showLoading = false;
      // }
    },
    showAlert(res) {
      this.flashMessageData = res;
      this.alertToggle = true;
    },
    onUpdatePhone(payload, index) {
      if (payload === 'delete') {
        this.phoneObject.splice(index, 1);
        return;
      }
      if (index <= this.phoneObject.length - 1)
        this.phoneObject[index] = payload;
      else this.phoneObject.push(payload);
    },
  },
};
</script>
<style scoped>
/* .close-btn {
  color: rgba(0, 0, 0, 0.87);
} */
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 90%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
.modal-header {
  position: sticky; 
  top: 0;
  width: 100% !important;
  background: #fff;
  z-index: 9;
  padding: 0 1rem;
}
</style>
